import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spinner, Form } from 'react-bootstrap';
import '../styles/TallesAdminCard.css';

const API_URL = process.env.REACT_APP_API_URL || "/";

// ...existing code...
const TallesAdminCards = ({ talles }) => {
  const [filtro, setFiltro] = useState('');
  // Solo mostrar empleados con al menos un talle cargado
  const filtrados = talles.filter(t => {
    const tieneTalle = t.camisa_invierno || t.pantalon_invierno || t.campera || t.camisa_verano || t.borcego;
    return tieneTalle && String(t.legajo).includes(filtro.trim());
  });
  return (
    <div className="talles-cards-container">
      <Form.Control
        type="text"
        placeholder="Buscar por legajo"
        value={filtro}
        onChange={e => setFiltro(e.target.value)}
        className="mb-4"
      />
      {!talles || talles.length === 0 ? (
        <Spinner animation="border" />
      ) : (
        <Row xs={1} md={2} lg={3} className="g-4 talles-cards-grid">
          {filtrados.map((t, i) => {
            return (
              <Col key={i}>
                <Card className="talle-card">
                  <Card.Body>
                    <Card.Title className="talle-card-title">{t.nombre}</Card.Title>
                    <Card.Subtitle className="talle-card-subtitle">Legajo: {t.legajo}</Card.Subtitle>
                    <Card.Text className="talle-card-text">
                      <div className="talle-seccion">
                        <span className="talle-titulo">🧥 Invierno</span>
                        <div><strong>Camisa:</strong> {t.camisa_invierno || '-'}</div>
                        <div><strong>Pantalón:</strong> {t.pantalon_invierno || '-'}</div>
                        <div><strong>Campera:</strong> {t.campera || '-'}</div>
                      </div>
                      <div className="talle-seccion">
                        <span className="talle-titulo">☀️ Verano</span>
                        <div><strong>Remera/Camisa Verano:</strong> {t.remera || t.camisa_verano || '-'}</div>
                        <div><strong>Pantalón Verano:</strong> {t.pantalon_verano || '-'}</div>
                      </div>
                      <div className="talle-seccion">
                        <span className="talle-titulo">👟 General</span>
                        <div><strong>Borcego:</strong> {t.borcego || '-'}</div>
                      </div>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default TallesAdminCards;
